import type { Variants } from 'motion/react'

// DESIGN.md §Motion: enter with ease-out, "long" = 400ms, no blur or bounce.
export const EASE = [0.16, 1, 0.3, 1] as const
export const DURATION = 0.4
export const Y_DISTANCE = 16
export const STAGGER = 0.08
export const VIEWPORT = { once: true, margin: '-80px' } as const

export const fadeInItem: Variants = {
  hidden: { opacity: 0, y: Y_DISTANCE },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION, ease: EASE },
  },
}

export const fadeInContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: STAGGER } },
}
